import { render, staticRenderFns } from "./UserAdd.vue?vue&type=template&id=64567f89&"
import script from "./UserAdd.vue?vue&type=script&lang=ts&"
export * from "./UserAdd.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports